import React, {useState} from "react";
import {PageHeader} from "../../../components/PageHeader";
import NoticeListType from "./subPages/NoticeListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getNoticeList} from "../../../api/notice/NoticeService";
import {useParams} from "react-router-dom";

function NoticeList() {
    const {type: typeParam} = useParams();
    const noticeGubun = typeParam === "request" ? "request" : "main";
    const [checked, setChecked] = useState([]);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    };

    const {newData, pageInfo, dataHook} =
        useRequestData((conditions, pageable) => {
            const finalConditions = {
                ...conditions,
                gubun: noticeGubun,
                type: noticeGubun,
            };
            return getNoticeList(finalConditions, pageable);
        }, initDate, `notice_${noticeGubun}`);


    return (
        <>
            <div className="common-container container-height-full">
                {noticeGubun === "request" ?
                    <PageHeader header={"요청공지사항"} indicator={"서비스요청 > 요청공지사항"} /> :
                    <PageHeader header={"공지사항관리"} indicator={"환경설정 > 알람관리 > 공지사항관리"} />}

                <NoticeListType
                    data={newData}
                    date={initDate}
                    pageInfo={pageInfo}
                    dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}}
                    type={noticeGubun}
                />

            </div>
        </>
    );
}

export default NoticeList;